import { render, staticRenderFns } from "./UserTitles.vue?vue&type=template&id=b114eec2"
import script from "./UserTitles.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserTitles.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports